import { WSAlert } from "@wingspanhq/fe-component-library";
import { useHistory } from "react-router-dom";
import { PATH_ONBOARDING_VERIFICAIONS_TAX } from "../../Onboarding";

export const ConfirmTaxInformationForLegacyUserAlert: React.FC = () => {
  const history = useHistory();

  return (
    <WSAlert
      title="Confirm your tax information"
      theme="warning"
      icon="alert"
      action={{
        text: "Confirm your tax information",
        onClick: () => {
          history.push(PATH_ONBOARDING_VERIFICAIONS_TAX);
        }
      }}
    >
      Our verification system has been upgraded. Please confirm your tax
      information to ensure compliant engagement with your client(s). This is a
      one-time update maintain accurate records.
    </WSAlert>
  );
};
